import React from 'react';
import Hero from '../../presentational/Hero';

function HeroContainer(props) {
  return (
    <Hero fluid link="bb-history">
      <div className="center-left">
        <h1><em>Alex Cosmetics</em><br/> BB Cream</h1>
        <p>The Original</p>
      </div>
    </Hero>
  )
}

export default HeroContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/BBPage/HeroContainer.jsx
 **/